// src/config.js

 const config = {
   // Erst mal aus dem runtime-Skript, sonst Fallback
   frontendURL: window._env_.FRONTEND_URL || 'http://localhost:3000',
   backendURL:  window._env_.BACKEND_URL  || 'http://localhost:3001',
 };

export default config;
